export function TableIndex({ comerciosIndex, selectedIndex, onIndexClick }) {

  const alphabet = 'abcdefghijklmnopqrstuvwxyz'.toUpperCase().split('');

  return (
    <ul className="table-comercios--index py-1">
      {alphabet.map((letter, index) => {
        const isActive = selectedIndex === letter;
        const isDisabled = !comerciosIndex.includes(letter);
        return (
          <li key={index}>
            <a
              data-index={letter}
              href={`#${letter}`}
              className={`${isActive ? 'is-active' : ''} ${isDisabled ? 'is-disabled' : ''}`}
              onClick={onIndexClick} >{letter}</a>
          </li>
        )
      })}
    </ul>
  );
}